import {
  AdminQuestionnaireFilterSection,
  AdminQuestionnaireExportList,
} from '@exam-center/admin-questionnaire-export';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, PaperSection, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function PermissionRequiredAdminQuestionnairesPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_QUESTIONNAIRE_MANAGEMENT.QUESTIONNAIRE_REPORT.VIEW,
      ]}
    >
      <AdminQuestionnaires />
    </PermissionGuard>
  );
}

function AdminQuestionnaires() {
  return (
    <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
      <Flex component='header' sx={(theme) => ({ p: theme.spacing(6, 7) })}>
        <Text variant='h1'>แบบสอบถาม</Text>
      </Flex>
      <Flex sx={(theme) => ({ p: theme.spacing(6), flexGrow: 1 })}>
        <PaperSection title='รายงานแบบสอบถาม'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <AdminQuestionnaireFilterSection />
            <AdminQuestionnaireExportList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
